import type { ReactNode } from "react"
import { Card } from "@/components/ui/card"

/** A titled card of `NotificationRow`s; `id` labels the section for assistive technology. */
export function NotificationGroup({
  id,
  title,
  description,
  children,
}: {
  id: string
  title: string
  description: string
  children: ReactNode
}) {
  return (
    <section className="space-y-2" aria-labelledby={id}>
      <div className="space-y-0.5">
        <h2 id={id} className="text-sm font-semibold">{title}</h2>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
      <Card className="divide-y">{children}</Card>
    </section>
  )
}
